<template>
  <div>
    <modal
      name="team-create"
      :adaptive="true"
      :minHeight="545"
      :maxHeight="auto"
      :scrollable="true"
    >
      <div class="text-center mt-4">
        <h6 class="text-gray-600 text-xl font-bold">Create New Team</h6>
      </div>
      <div style="margin: 20px">
        <FormulateForm @submit="createTeam">
          <div class="flex flex-wrap">
            <div class="w-full xl:w-12/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="name"
                label="Name*"
                validation="required"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
              />
            </div>
            <div class="w-full xl:w-12/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="name"
                label="Owner*"
                validation="required"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
                disabled
                :value="currentUser.first_name + ' ' + currentUser.last_name"
              />
            </div>
            <div class="w-full xl:w-12/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="description"
                label="Description*"
                validation="required"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
              />
            </div>
            <div class="w-full xl:w-12/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="image"
                name="image"
                v-on:change="onChangeFileUpload($event)"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                label="Select an image to upload"
                help="Select a png or jpg to upload."
                validation="mime:image/jpeg,image/png"
              />
            </div>
            <div class="w-full xl:w-12/12 xl:mb-0 px-2 mt-5">
              <FormulateInput
                input-class="px-4 py-2 w-full rounded bg-blue-500 text-white hover:bg-blue-700"
                type="submit"
                name="Create"
              />
            </div>
          </div>
        </FormulateForm>
      </div>
    </modal>
  </div>
</template>
<script>
/* 
  Class: ModalTeamCreate
  Description: This class representing a team create modal.
*/

/* Imports */
import TeamService from "@/services/team.service";
import UserService from "@/services/user.service";
/* /Imports/ */

export default {
  /* 
    Define data with custom teams state values. 
  */
  data() {
    return {
      image: null,
    };
  },

  /* 
    Define methods for separate different logic. 
  */
  methods: {
    /* 
      Upload team image from the form.
    */
    onChangeFileUpload(event) {
      this.image = event.target.files[0];
    },
    
    /* 
      Call IncidentService class to create new team.
    */
    createTeam(data) {
      const formData = new FormData();

      formData.append("name", data.name);
      formData.append("description", data.description);

      if (this.image != null) {
        formData.append("image", this.image);
      }
      
      TeamService.createTeam(formData).then(() => {
        UserService.getUser(this.currentUser.id).then((response) => {
          localStorage.setItem("user", JSON.stringify(response));
          location.reload();
        });
      });
    },
  },

  /* 
    Define computed properties to obtain different getters and setters and save them into the instance. 
  */
  computed: {
    /* 
      Obtain current user object from the store. 
    */
    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  /* 
    Check if user is authenticated.
  */
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  },
};
</script>
